import { withAsync } from '@/components/Async'
import Blank from '@/layouts/Blank'
import type { RouteConfig } from 'react-router-config'

const routes: RouteConfig[] = [
  {
    path: '/subscribe',
    name: 'subscribe',
    menuTitle: 'subscribe.config.title',
    component: Blank,
    permissionCode: 'subscribe',
    routes: [
      // 订阅页
      {
        path: '/',
        component: withAsync(() => import(/* webpackChunkName: "Subscribe" */ '@/containers/Subscribe/Config')),
        exact: true,
        main: true,
      },
      // 账单
      {
        path: '/bills',
        component: withAsync(() => import(/* webpackChunkName: "Subscribe" */ '@/containers/Subscribe/Bills')),
        exact: true,
      },
    ],
  },
]

export default routes
